<template>
  <div class="menu-item" v-on:click="onClick"
       :class="{ disabled: disabled }">
    <span class="menu-item-title">
      {{ title }}
      <span v-if="showNewBadge"
            class="is-new-banner">
        חדש!</span>
      <img v-else-if="icon" class="icon" :src="require(`@/assets/${icon}`)">
    </span>
  </div>
</template>

<script>

export default {
  name: 'MenuItem',
  props: {
    title: {
      type: String,
      required: true,
    },
    onClick: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
    showNewBadge: {
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">

@import '../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../scss/mixins';

.menu-item {
  margin-bottom: 30px;
  font-size: 20px;
  cursor: pointer;

  .icon {
    margin-right: 10px;
    vertical-align: middle;
  }

  .menu-item-title {
    position: relative;
    .is-new-banner {
      @include is-new-banner;
    }
  }
}
</style>
